/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Absolute contact-local schedule selected from workflow instructions.
 */
export type EmployeeExecutionAbsoluteSchedule = {
    /**
     * Stable discriminator for an absolute contact-local schedule.
     */
    kind: EmployeeExecutionAbsoluteSchedule.kind;
    /**
     * Contact-local ISO timestamp without a timezone suffix.
     */
    dueAt: string;
};
export namespace EmployeeExecutionAbsoluteSchedule {
    /**
     * Stable discriminator for an absolute contact-local schedule.
     */
    export enum kind {
        ABSOLUTE = 'absolute',
    }
}

